import React from "react";
import ReactDOM from "react-dom";
import isObject = require("lodash/isObject");
import isDate = require("lodash/isDate");
import {isArrayLike} from "mobx";





export function findOverlayPlacement(triggerEl, width, height) {
  let bodyRect = document.body.getBoundingClientRect(),
    elemRect = triggerEl.getBoundingClientRect();

  let offset = bodyRect.bottom - elemRect.bottom;
  if (offset > height) {
    return "bottom";
  }

  offset   = bodyRect.right - elemRect.right;
  if (offset > width) {
    return "right";
  }

  offset   = elemRect.top - bodyRect.top;
  if (offset > height) {
    return "top";
  }

  return "left";
}

export function computeHeight(bodyRect: ClientRect, aceRef): number {
  if (aceRef) {
    let aceElement = ReactDOM.findDOMNode(aceRef);
    if (aceElement) {
      let aceRect = aceElement.getBoundingClientRect();
      return (bodyRect.height - (aceRect.top - bodyRect.top) - 10);
    }
  }

  return null;
}


export function topDifference(element, container): number {
  return topFromWindow(element) - topFromWindow(container);
}

export function topFromWindow(element): number {
  if (!element || element === window) return 0;

  return element.offsetTop + topFromWindow(element.offsetParent);
}



function encode(val) {
  return encodeURIComponent(val).
  replace(/%40/gi, '@').
  replace(/%3A/gi, ':').
  replace(/%24/g, '$').
  replace(/%2C/gi, ',').
  replace(/%20/g, '+').
  replace(/%5B/gi, '[').
  replace(/%5D/gi, ']');
}

function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

export function buildURL(url, params?: {[key: string]: any}, paramsSerializer?: any) {
  if (!params) {
    return url;
  }

  let serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    let parts = [];

    Object.entries(params).forEach( ([key, val]: [string, any], index: number) => {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (isArrayLike(val)) {
        key = key + '[]';
      }

      if (!isArrayLike(val)) {
        val = [val];
      }

      (<Array<any>> val).forEach(v => {
        if (isDate(v)) {
          v = v.toISOString();
        } else if (isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });


    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}


const hasOwn = {}.hasOwnProperty;

export function classNames (...args) {
  const classes = [];

  for (let i = 0; i < arguments.length; i++) {
    let arg = arguments[i];
    if (!arg) continue;

    let argType = typeof arg;

    if (argType === 'string' || argType === 'number') {
      classes.push(arg);
    } else if (Array.isArray(arg)) {
      classes.push(classNames.apply(null, arg));
    } else if (argType === 'object') {
      for (let key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(' ');
}


export const clsx = (...styles: React.CSSProperties[]): React.CSSProperties => {
  return styles.reduce((acc, style) => ({ ...acc, ...style }), {});
};



// WEBPACK FOOTER //
// ./src/core/common/utils/domUtils.ts